var _defs, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCellphoneMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_3735",
    "data-name": "Grupo 3735",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76.193,
    height: 123.675,
    viewBox: "0 0 76.193 123.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff005d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1121",
    "data-name": "Caminho 1121",
    d: "M9.016,121.472c-4.38-.008-7.1-3.277-6.752-8.1H61.5c.739,4.545-2.127,8.083-6.632,8.092q-12.328.026-24.653.026-10.6,0-21.2-.017M8.949,2.2c2.356-.035,4.713-.027,7.07-.018q1.593.005,3.186.007Q37,2.185,54.8,2.184c4.57,0,7.526,3.534,6.787,8.191H2.435A6.607,6.607,0,0,1,8.949,2.2M8.774,0A8.679,8.679,0,0,0,0,8.689Q0,61.814.022,114.941a8.672,8.672,0,0,0,8.751,8.725q12.032.009,24.063.009h2.842q9.849,0,19.7,0a7,7,0,0,0,1.555-.13A8.839,8.839,0,0,0,64,114.571c0-7.784,0-15.693,0-23.477H61.658q-.008,9.28-.018,18.558v1.266H2.28V12.795c.471-.032.9-.086,1.32-.086q28.373-.041,56.746-.1c1.118,0,1.412.318,1.41,1.418q-.014,7.845-.026,15.692h2.249q0-10.325-.021-20.649A8.749,8.749,0,0,0,54.9.014Q35.552,0,16.211,0H8.774",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1122",
    "data-name": "Caminho 1122",
    d: "M62.23,231.974q-3.8.006-7.606,0v.005c-2.576,0-5.151,0-7.727,0-.823,0-1.611.095-1.626,1.145s.788,1.18,1.6,1.181q7.667.014,15.333.013c.85,0,1.713-.1,1.682-1.23-.029-1.04-.834-1.115-1.641-1.115H62.23",
    transform: "translate(-45.271 -231.974)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1123",
    "data-name": "Caminho 1123",
    d: "M46.466,116a4.9,4.9,0,0,1-5.192-5.218c-.009-2.627-.023-5.254.01-7.881a1.776,1.776,0,0,0-1.065-1.78c-4.344-2.291-8.672-4.611-13-6.922-.211-.112-.419-.231-.745-.411l8.249-4.4c1.784-.952,3.551-1.938,5.36-2.84a1.932,1.932,0,0,0,1.21-1.988c-.049-2.578-.023-5.157-.015-7.736a4.91,4.91,0,0,1,5.251-5.235q16.958,0,33.915,0A4.938,4.938,0,0,1,85.7,76.837q.006,16.955,0,33.91A4.932,4.932,0,0,1,80.454,116q-8.5,0-16.994,0t-16.994,0m.065-46.875A7.369,7.369,0,0,0,38.8,76.849c-.009,2.29-.02,4.58.012,6.869a1.013,1.013,0,0,1-.643,1.05c-4.174,2.2-8.327,4.44-12.5,6.64a2.539,2.539,0,0,0,.005,4.787c4.175,2.2,8.329,4.438,12.5,6.639a1.016,1.016,0,0,1,.638,1.057c-.034,1.975-.024,3.953-.009,5.928a15.041,15.041,0,0,0,.114,2.522,7.315,7.315,0,0,0,7.4,6.124q5.952.02,11.9.008l5.237,0q8.461,0,16.923,0a7.389,7.389,0,0,0,7.774-7.756q0-7.634,0-15.269V91.256q0-7.191,0-14.382a7.386,7.386,0,0,0-7.712-7.745q-8.311-.005-16.62,0-8.649,0-17.3,0",
    transform: "translate(-23.984 -69.124)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1124",
    "data-name": "Caminho 1124",
    d: "M73.361,108.558v-6.133c.969-.12,2.376.311,2.381-1.249s-1.386-1.163-2.38-1.27V93.8c.966-.163,2.433.311,2.379-1.329-.049-1.491-1.406-1.1-2.4-1.228,0-1.288-.038-2.56.017-3.827A1.123,1.123,0,0,1,74.4,86.374a4.165,4.165,0,0,1,.721-.024H98.691c1.426,0,1.8.372,1.8,1.8q0,13.01,0,26.023c0,1.437-.367,1.81-1.784,1.81q-11.821,0-23.641,0c-1.374,0-1.74-.375-1.741-1.768,0-1.03,0-2.06,0-3.122,1.02-.126,2.414.266,2.42-1.281,0-1.234-.863-1.231-1.71-1.228H73.91a4.746,4.746,0,0,1-.549-.024m1.414-24.671a3.7,3.7,0,0,0-3.916,3.887c-.007,1.13,0,2.26,0,3.459-1.014.143-2.373-.263-2.421,1.237-.054,1.651,1.42,1.153,2.379,1.332v6.1c-.968.123-2.332-.3-2.378,1.205-.05,1.635,1.391,1.2,2.38,1.321v6.121c-.972.141-2.389-.323-2.382,1.261.007,1.56,1.406,1.144,2.422,1.288,0,1.176-.006,2.327,0,3.478a3.685,3.685,0,0,0,3.86,3.866q12.183.011,24.367,0a3.694,3.694,0,0,0,3.866-3.873q.015-13.41,0-26.821a3.7,3.7,0,0,0-3.882-3.859q-6.179-.006-12.357-.006-5.969,0-11.938,0",
    transform: "translate(-68.436 -83.883)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1125",
    "data-name": "Caminho 1125",
    d: "M93.055,111.82a4.42,4.42,0,0,1,2.208-3.389,1.3,1.3,0,0,1,.924-.134,6.5,6.5,0,0,0,3.422.01,1.384,1.384,0,0,1,.986.15,4.609,4.609,0,0,1,2.221,3.695c.087,1.219.018,2.449.018,3.731H93.027c0-1.38-.1-2.733.028-4.063m4.849-5.743a3.694,3.694,0,1,1,.009-7.388,3.694,3.694,0,0,1,0,7.388h0m-4.218-8.2a6.209,6.209,0,0,0-.234,8.78,7.72,7.72,0,0,0-2.942,6.857c.044.816-.01,1.638.014,2.457a2.369,2.369,0,0,0,2.427,2.43q4.953.038,9.906,0a2.393,2.393,0,0,0,2.451-2.487c.016-1.156.023-2.314,0-3.47a7.33,7.33,0,0,0-2.385-5.321c-.17-.162-.344-.321-.513-.479A6.187,6.187,0,0,0,97.915,96.2a6.173,6.173,0,0,0-4.228,1.676",
    transform: "translate(-90.494 -96.197)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3726",
    "data-name": "Grupo 3726",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3725",
    "data-name": "Grupo 3725",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1592",
    "data-name": "Ret\\xE2ngulo 1592",
    width: 64.004,
    height: 123.675,
    transform: "translate(-0.003)",
    fill: "url(#linear-gradient)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3728",
    "data-name": "Grupo 3728",
    transform: "translate(22.673 116.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3727",
    "data-name": "Grupo 3727",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1593",
    "data-name": "Ret\\xE2ngulo 1593",
    width: 18.662,
    height: 2.346,
    transform: "translate(-0.015)",
    fill: "url(#linear-gradient)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3730",
    "data-name": "Grupo 3730",
    transform: "translate(12.012 34.62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3729",
    "data-name": "Grupo 3729",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1594",
    "data-name": "Ret\\xE2ngulo 1594",
    width: 64.183,
    height: 49.355,
    transform: "translate(-0.002 0)",
    fill: "url(#linear-gradient)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3732",
    "data-name": "Grupo 3732",
    transform: "translate(34.276 42.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3731",
    "data-name": "Grupo 3731",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1595",
    "data-name": "Ret\\xE2ngulo 1595",
    width: 34.579,
    height: 34.565,
    transform: "translate(-0.052 0)",
    fill: "url(#linear-gradient)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3734",
    "data-name": "Grupo 3734",
    transform: "translate(45.323 48.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3733",
    "data-name": "Grupo 3733",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1596",
    "data-name": "Ret\\xE2ngulo 1596",
    width: 14.967,
    height: 22.225,
    transform: "translate(-0.131 0)",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCellphoneMessage);
export default __webpack_public_path__ + "static/media/icon-cellphoneMessage.adff2c8d2a376f99dcdb519eb1545a9a.svg";
export { ForwardRef as ReactComponent };